import { TabsDesignTokens } from '@primeuix/themes/aura/tabs';

export const tabsTokens: TabsDesignTokens = {
  root: {
    transitionDuration: '{transition.duration}',
  },
  tablist: {
    borderWidth: '0 0 1px 0',
    background: 'transparent',
    borderColor: '{color.border.main}',
  },
  tab: {
    background: 'transparent',
    hoverBackground: 'transparent',
    activeBackground: 'transparent',
    borderWidth: '0 0 1px 0',
    borderColor: 'transparent',
    hoverBorderColor: '{color.border.main}',
    activeBorderColor: '{color.brand.main}',
    color: '{color.main.secondary}',
    hoverColor: '{color.main.primary}',
    activeColor: '{color.brand.main}',
    padding: '0.594rem 1rem',
    fontWeight: '600',
    margin: '0 0 -1px 0',
    gap: '0.5rem',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '-1',
      shadow: '{focus.ring.shadow}',
    },
  },
  tabpanel: {
    background: 'transparent',
    color: '{color.main.primary}',
    padding: '0.875rem 1.125rem 1.125rem 1.125rem',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
  },
  navButton: {
    background: '{color.background.front}',
    color: '{color.main.secondary}',
    hoverColor: '{color.main.primary}',
    width: '2.5rem',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '-1',
      shadow: '{focus.ring.shadow}',
    },
  },
  activeBar: {
    height: '1px',
    bottom: '-1px',
    background: '{color.brand.main}',
  },
  css: () => `
    .p-tab {
      display: flex;
    }
  `,
  colorScheme: {
    light: {
      navButton: {
        shadow: '0px 0px 10px 50px rgba(249, 250, 251, 0.6)',
      },
    },
    dark: {
      navButton: {
        shadow: '0px 0px 10px 50px rgba(16, 14, 52, 0.6)',
      },
    },
  },
};
